'use client';
import React, { useState, useEffect, useRef } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

// ─── Data ────────────────────────────────────────────────────────────────────

const testimonials = [
{
  quote: "I started working at Brickwell when I was 16 years old during high school breaks. I became a full-time employee a little over 20 years ago, and I couldn't imagine being a part of any other organization.",
  name: 'Jed H',
  role: 'Vice President Transactions Closing Manager',
  image: "/assets/images/Jed_H-1776910977448.png",
  color: 'teal'
},
{
  quote: 'This company recognizes that employee satisfaction is the backbone of a happy workforce.',
  name: 'Takieya R',
  role: 'Regional Vice President',
  image: "/assets/images/Jennifer-1776911478068.png",
  color: 'orange'
},
{
  quote: "Lifting lives isn't just a slogan for our communities, but for our teammates as well and the family we have at Brickwell. It makes going to work so much easier when you know you have a team of people supporting you and watching your back.",
  name: 'Elijah E',
  role: 'Community Manager',
  image: 'https://tmo.com/wp-content/uploads/2024/07/elijah.png',
  color: 'teal'
},
{
  quote: "I have been working with Brickwell Housing for over twelve years and I have never felt lonely. Brickwell has been helping my family and I since the beginning and throughout my daughter\'s university. Brickwell not only cares for you but for your whole family.",
  name: 'Francisco C',
  role: 'Maintenance Superintendent',
  image: "/assets/images/Francisco-1776910871734.png",
  color: 'orange'
},
{
  quote: "I have never worked for a company who treats their employees as well as Brickwell treats us, which is why I've been here since 2009. It truly feels like a family!",
  name: 'Jennifer Z',
  role: 'Community Manager',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1232efbbb-1768908216051.png",
  color: 'teal'
}];


const coreValues = [
{
  title: 'Carpe diem and then some',
  image: "https://images.unsplash.com/photo-1619353115661-d27a0c12d2f5",
  description: "We knock on opportunity's door. Brickwell Housing has always been a pioneering company, which means we're a company of pioneers. We don't wait for opportunity to knock, we seize the moment before it gets away. If you see a chance to make a difference, don't wait until the time is right. The time is now."
},
{
  title: 'Our status is never quo',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1927c6eaf-1765220741931.png",
  description: "We challenge conventional wisdom every day. We remain open to possibilities, ever curious about the next big thing for all of us. We ask why, and more importantly, why not. Brickwell thrives on innovation—not for the sake of change—but for the sake of getting better, smarter, and rising higher in everything we do."
},
{
  title: "Let\'s go out a little further",
  image: "https://images.unsplash.com/photo-1543170495-526c0dc299c8",
  description: "To catch the biggest fish, you have to sail into their waters. Pioneering, innovating, and 'going beyond' are all part of our DNA, so if you see a chance to go out a little further, take it."
},
{
  title: 'I got your back',
  image: "https://images.unsplash.com/photo-1590537909675-bff557032c9d",
  description: "We act with integrity and support each other. We respect our individualism while knowing our success depends on this golden rule: all for one and one for all. We're all in this together."
},
{
  title: 'Walk the job',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_122599b78-1768744467622.png",
  description: "We plan carefully, we triple-check. We talk with and learn from one another. We compare notes and keep each other focused. It's how we know our strengths and our vulnerabilities."
},
{
  title: 'Keep it real',
  image: "https://images.unsplash.com/photo-1602810319428-019690571b5b",
  description: "We're straight with each other, especially when we disagree. When we say we'll do something, we do it. We keep it professional, and avoid making it personal."
},
{
  title: 'Do well by doing the extraordinary',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1818ebcbd-1777445533591.png",
  description: "We believe everyone deserves a shot at prosperity. We invest in people, living and learning; anything we can do to help lift lives to the next level, and build great equity for all involved."
},
{
  title: 'Laugh anytime',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ae310bb8-1772094602601.png",
  description: "We take our mission seriously, but never ourselves. Seriously, we work hard, play hard, and believe in laughing out loud."
},
{
  title: 'We seek the highest ground',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_112c56764-1776818226477.png",
  description: "At Brickwell, we believe we fulfill our mission of Lifting Lives when everyone has the opportunity to be included. When we say everyone, we mean EVERYONE. We embrace and leverage our individual differences to the benefit of our teammates, our business, and the communities we serve."
}];


const totalRewards = [
{
  title: 'Take Care of Yourself',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_13152cea8-1769358109066.png",
  description: 'Choose from a variety of plans that will best serve your needs and lifestyle. We offer medical options that include features like vision, dental, health savings and health reimbursement accounts so you can remain happy, healthy and well taken care of.'
},
{
  title: 'Balance Work and Life',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_169ca59d3-1773300462835.png",
  description: "As much as we love to see your smiling face every day, we understand the importance of time off. Brickwell provides sick, vacation, holiday and personal paid time off so you're recharged and ready to lift lives!"
},
{
  title: 'Make Wellness a Priority',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_12d20e4ba-1768758403293.png",
  description: "We believe that investing in your wellness has a positive impact on the lives you touch and the communities you\'re a part of. That\'s why we offer a wellness rewards program for both you and your family."
},
{
  title: 'Keep Your Finances in Check',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_10e56706c-1765125167059.png",
  description: 'Flexible spending accounts and a financial wellness program means you can worry less about money to focus more on your work, family and happiness.'
},
{
  title: 'Plan for Your Future',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1023930b8-1770602854425.png",
  description: "With life insurance and 401K retirement plan options, you'll feel confident knowing you're setting yourself up for a successful future."
}];


const inclusionItems = [
{
  title: 'DEI Council',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1464abcb1-1767088355748.png",
  description: 'The Brickwell Diversity, Equity, and Inclusion Council assists with making sure every voice is heard. The Council is responsible for advising leadership on the company\'s inclusion and diversity needs, recommending new approaches, policies, and procedures.'
},
{
  title: 'Annual Jackie Jones Award',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c60bd355-1768335378885.png",
  description: 'Our late teammate Jackie Jones is remembered as a compassionate, dynamic, and iconic industry trailblazer. Each year, the award named in her honor is given to an individual or group of teammates who are an integral part of advancing diversity, equity, and inclusion.'
},
{
  title: 'Employee Resource Groups',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_120138626-1775842765067.png",
  description: "Brickwell's teammate-led Employee Resource Groups (ERGs) serve as an open environment and welcoming space for teammates to support one another's experiences in their careers or personal lives."
},
{
  title: 'DEI Week',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_196e0d854-1777272201165.png",
  description: "Brickwell's annual DEI Week is held in April to encourage teammates to set aside time to participate in educational webinars and activities, and access DEI resources such as books, articles, and videos."
},
{
  title: 'Section 3, MBE & WBE Hiring',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_112c56764-1776818226477.png",
  description: 'Brickwell has a proven track record of meeting or exceeding Section 3/MBE/WBE requirements and we always work to ensure that our vendors, partners, and subcontractors share our goal.'
}];


const teaserCards = [
{
  title: 'Scholarships for Children of Employees',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_11c86a7c3-1768050967993.png",
  alt: 'Students studying together in a bright classroom environment',
  description: 'We believe in education – and in taking care of our own – so your children will be able to apply for the Brickwell Employee Scholarship Program.'
},
{
  title: 'Learning Center',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_11fed47f0-1768443459801.png",
  alt: 'Professional development workshop with employees collaborating',
  description: 'We offer classes and workshops to help you grow professionally and personally. We believe in going out a little further to help you reach your full potential.'
},
{
  title: 'Giving Back',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_13fe4dbcf-1772796731977.png",
  alt: 'Community volunteers working together on a neighborhood project',
  description: 'Nothing feels better than helping others, so from Thanksgiving turkeys to our non-profit organization Better Tomorrows, we offer hundreds of ways to give back to our neighbors.'
}];


const teamCards = [
{
  title: 'Corporate Support',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e9a9e604-1772488910748.png",
  alt: 'Corporate support team members working in a modern office',
  description: 'Accounting, compliance, marketing, IT, HR, and administrative functions that support all our integrated business lines and our legacy of making the world a better place to live wherever we build and manage it.'
},
{
  title: 'Development & Investment Management',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_11e1e8393-1777272191882.png",
  alt: 'Development team reviewing architectural plans for a new housing project',
  description: 'Every role involved from a project\'s conception to completion, stabilization, and ongoing operations, including development, finance, underwriting, and property and asset managers.'
},
{
  title: 'Property Management & On-Site',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1920224de-1779936772314.png",
  alt: 'Property management team member assisting a resident at a housing community',
  description: 'We are always hiring for regional community managers, facility and maintenance technicians, leasing agents, and other on-site positions to serve our residents and our growing portfolio nationwide.'
},
{
  title: 'Construction',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_195017ff3-1772202547308.png",
  alt: 'Construction workers building a new residential community',
  description: 'From owners reps to project executives to estimators, our construction teammates can build a rewarding career journey at Brickwell.'
}];


// ─── Popup Component ─────────────────────────────────────────────────────────

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  items: {title: string;image: string;description: string;}[];
}

function Popup({ isOpen, onClose, title, items }: PopupProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setCurrentIndex(0);
    } else {
      document.body.style.overflow = '';
    }
    return () => {document.body.style.overflow = '';};
  }, [isOpen]);

  if (!isOpen) return null;

  const prev = () => setCurrentIndex((i) => i > 0 ? i - 1 : items.length - 1);
  const next = () => setCurrentIndex((i) => i < items.length - 1 ? i + 1 : 0);
  const item = items[currentIndex];

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '16px'
      }}>

      <div
        onClick={onClose}
        style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)' }} />

      <div className="popup-inner" style={{
        position: 'relative', zIndex: 1,
        backgroundColor: '#ffffff',
        width: '90%', maxWidth: '900px',
        maxHeight: '90vh', overflow: 'hidden',
        display: 'flex', flexDirection: 'column'
      }}>
        {/* Close */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: '16px', right: '16px',
            background: 'none', border: 'none', cursor: 'pointer',
            zIndex: 2, padding: '8px'
          }}
          aria-label="Close popup">

          <svg width="20" height="20" viewBox="0 0 20 20" fill="#333">
            <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" />
          </svg>
        </button>

        {/* Content */}
        <div className="popup-content" style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          {/* Image */}
          <div className="popup-image" style={{ width: '40%', flexShrink: 0, overflow: 'hidden' }}>
            <img
              src={item.image}
              alt={item.title}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
          </div>
          {/* Text */}
          <div style={{ flex: 1, padding: '48px 40px 40px', overflowY: 'auto' }}>
            <h3 style={{
              fontSize: '24px', fontWeight: '600',
              color: '#003c82', marginBottom: '16px',
              fontFamily: 'Montserrat, sans-serif'
            }}>{item.title}</h3>
            <p style={{
              fontSize: '15px', lineHeight: '1.7',
              color: '#555', fontFamily: 'Montserrat, sans-serif'
            }}>{item.description}</p>
          </div>
        </div>

        {/* Navigation */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '16px 24px', borderTop: '1px solid #e0e0e0',
          backgroundColor: '#f8f9fa'
        }}>
          <button
            onClick={prev}
            style={{
              background: 'none', border: '2px solid #003c82',
              color: '#003c82', padding: '8px 20px',
              cursor: 'pointer', fontFamily: 'Montserrat, sans-serif',
              fontSize: '13px', fontWeight: '600'
            }}>
            ← Prev
          </button>
          <span style={{ fontSize: '13px', color: '#888', fontFamily: 'Montserrat, sans-serif' }}>
            {currentIndex + 1} / {items.length}
          </span>
          <button
            onClick={next}
            style={{
              backgroundColor: '#003c82', border: '2px solid #003c82',
              color: '#ffffff', padding: '8px 20px',
              cursor: 'pointer', fontFamily: 'Montserrat, sans-serif',
              fontSize: '13px', fontWeight: '600'
            }}>
            Next →
          </button>
        </div>
      </div>
    </div>);
}

// ─── Team Popup ───────────────────────────────────────────────────────────────

interface TeamPopupProps {
  isOpen: boolean;
  onClose: () => void;
  card: {title: string;image: string;alt: string;description: string;} | null;
}

function TeamPopup({ isOpen, onClose, card }: TeamPopupProps) {
  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';else
    document.body.style.overflow = '';
    return () => {document.body.style.overflow = '';};
  }, [isOpen]);

  if (!isOpen || !card) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)' }} />
      <div style={{
        position: 'relative', zIndex: 1,
        backgroundColor: '#ffffff',
        width: '90%', maxWidth: '600px',
        padding: '48px 40px'
      }}>
        <button
          onClick={onClose}
          style={{ position: 'absolute', top: '16px', right: '16px', background: 'none', border: 'none', cursor: 'pointer' }}
          aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="#333">
            <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" />
          </svg>
        </button>
        <h3 style={{ fontSize: '26px', fontWeight: '600', color: '#003c82', marginBottom: '16px', fontFamily: 'Montserrat, sans-serif' }}>{card.title}</h3>
        <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#555', fontFamily: 'Montserrat, sans-serif' }}>{card.description}</p>
      </div>
    </div>);
}

// ─── Main Page ────────────────────────────────────────────────────────────────

export default function CareersPage() {
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [activePopup, setActivePopup] = useState<'values' | 'rewards' | 'inclusion' | null>(null);
  const [activeTeamCard, setActiveTeamCard] = useState<typeof teamCards[0] | null>(null);
  const [teamPopupOpen, setTeamPopupOpen] = useState(false);
  const autoplayRef = useRef<ReturnType<typeof setInterval> | null>(null);

  // Testimonial autoplay
  useEffect(() => {
    autoplayRef.current = setInterval(() => {
      setTestimonialIndex((i) => (i + 1) % (testimonials.length - 1));
    }, 4000);
    return () => {if (autoplayRef.current) clearInterval(autoplayRef.current);};
  }, []);

  const visibleTestimonials = testimonials.slice(testimonialIndex, testimonialIndex + 3);
  if (visibleTestimonials.length < 3) {
    visibleTestimonials.push(...testimonials.slice(0, 3 - visibleTestimonials.length));
  }

  const openTeamPopup = (card: typeof teamCards[0]) => {
    setActiveTeamCard(card);
    setTeamPopupOpen(true);
  };

  return (
    <>
      <Header />

      {/* ── HERO ── */}
      <section
        id="careers-hero"
        className="careers-hero"
        style={{
          position: 'relative',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          backgroundColor: '#001a3d'
        }}>

        {/* Background image */}
        <div
          style={{
            position: 'absolute', inset: 0,
            backgroundImage: 'url(/assets/images/P3-1776941776544.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }} />

        {/* Overlay */}
        <div
          style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(45deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 60%, rgba(0,0,0,0) 100%)'
          }} />

        {/* Cyan decoration triangle */}
        <div
          className="hero-triangle"
          style={{
            position: 'absolute', bottom: 0, right: 0,
            width: '45%', height: '100px',
            backgroundColor: '#6dcff6',
            clipPath: 'polygon(100% 0, 100% 100%, 0 100%)'
          }} />

        {/* Content */}
        <div className="hero-content" style={{ position: 'relative', zIndex: 1, maxWidth: '1280px', margin: '0 auto', padding: '0 24px', width: '100%' }}>
          <div style={{ maxWidth: '640px', paddingTop: '80px' }}>
            <h1
              style={{
                fontSize: 'clamp(28px, 5vw, 54px)',
                lineHeight: 1.2,
                color: '#ffffff',
                fontWeight: 400,
                marginBottom: '32px',
                fontFamily: 'Montserrat, sans-serif'
              }}>
              The Promise of Lifting Lives Starts With Our Teammates
            </h1>
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section
        id="testimonials"
        style={{ padding: '80px 0', backgroundColor: '#ffffff', overflow: 'hidden' }}>

        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '24px'
            }}
            className="testimonials-grid">

            {visibleTestimonials.map((t, i) =>
            <div
              key={i}
              style={{
                backgroundColor: t.color === 'teal' ? '#00b195' : '#f05323',
                padding: '40px 32px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: '320px'
              }}>

                <div>
                  <div style={{ fontSize: '40px', color: 'rgba(255,255,255,0.4)', lineHeight: 1, marginBottom: '16px', fontFamily: 'Georgia, serif' }}>&ldquo;</div>
                  <blockquote
                  style={{
                    margin: 0, padding: 0,
                    fontSize: '16px', lineHeight: '1.6',
                    color: '#ffffff',
                    fontFamily: 'Montserrat, sans-serif',
                    fontStyle: 'normal'
                  }}>
                    {t.quote}
                  </blockquote>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: '32px' }}>
                  <img
                  src={t.image}
                  alt={`${t.name} - ${t.role} at Brickwell Housing`}
                  style={{
                    width: '56px', height: '56px',
                    borderRadius: '50%', objectFit: 'cover',
                    border: '3px solid rgba(255,255,255,0.4)'
                  }} />
                  <div>
                    <strong style={{ display: 'block', color: '#ffffff', fontSize: '15px', fontFamily: 'Montserrat, sans-serif' }}>{t.name}</strong>
                    <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '13px', fontFamily: 'Montserrat, sans-serif' }}>{t.role}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Pagination dots */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '32px' }}>
            {Array.from({ length: testimonials.length - 2 }).map((_, i) =>
            <button
              key={i}
              onClick={() => setTestimonialIndex(i)}
              style={{
                width: i === testimonialIndex ? '32px' : '10px',
                height: '10px',
                borderRadius: i === testimonialIndex ? '5px' : '50%',
                backgroundColor: i === testimonialIndex ? '#003c82' : '#ccc',
                border: 'none', cursor: 'pointer',
                transition: 'all 0.3s ease', padding: 0
              }}
              aria-label={`Go to testimonial ${i + 1}`} />
            )}
          </div>
        </div>
      </section>

      {/* ── WHY BRICKWELL ── */}
      <section
        id="why-brickwell"
        style={{
          padding: '80px 0',
          backgroundColor: '#ffffff',
          position: 'relative'
        }}>

        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '80px',
              alignItems: 'center'
            }}
            className="why-grid">

            {/* Left: Logo carousel */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div
                style={{
                  width: '100%', maxWidth: '420px',
                  backgroundColor: '#f0f8ff',
                  padding: '60px 40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_11466d124-1779936771528.png"
                  alt="Brickwell Housing award recognition logo"
                  style={{ maxWidth: '100%', height: 'auto' }} />
              </div>
            </div>
            {/* Right: Content */}
            <div>
              <strong
                style={{
                  display: 'block',
                  fontSize: '14px', fontWeight: '600',
                  color: '#00b195', letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  marginBottom: '12px',
                  fontFamily: 'Montserrat, sans-serif'
                }}>
                We&apos;re here to support you on your career journey
              </strong>
              <h2
                style={{
                  fontSize: 'clamp(28px, 3vw, 40px)',
                  fontWeight: 400,
                  color: '#003c82',
                  marginBottom: '24px',
                  fontFamily: 'Montserrat, sans-serif'
                }}>
                Why Brickwell?
              </h2>
              <div style={{ fontSize: '15px', lineHeight: '1.7', color: '#555', fontFamily: 'Montserrat, sans-serif' }}>
                <p style={{ marginBottom: '16px' }}>
                  Not only does Brickwell prepare you with the tools you need for a strong start with the company, but we also provide you the platform for never-ending possibilities. Our company continues to grow, and with that, we offer you the opportunity to grow with us.
                </p>
                <ul style={{ paddingLeft: '20px', margin: 0 }}>
                  <li style={{ marginBottom: '10px' }}>Our collaborative, team-centric approach to business means someone will always have your back on the job.</li>
                  <li style={{ marginBottom: '10px' }}>No matter the project or task at hand, we put the happiness and satisfaction of our teammates first.</li>
                  <li style={{ marginBottom: '10px' }}>You will be supported on your career journey, allowing you to try new things and step out of your comfort zone.</li>
                  <li>We believe in working hard, and playing just as hard!</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── BENEFITS / CULTURE & REWARDS ── */}
      <section
        id="values-benefits-dei"
        style={{
          padding: '80px 0',
          backgroundColor: '#e8f4fd'
        }}>

        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '24px'
            }}
            className="benefits-grid">

            {/* Core Values Card */}
            <div style={{ backgroundColor: '#ffffff', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
              <div style={{ height: '240px', overflow: 'hidden' }}>
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_1b8899a97-1768389747850.png"
                  alt="Team members embodying Brickwell Housing core values in a collaborative setting"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
              </div>
              <div style={{ padding: '28px 24px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  <strong style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#00b195', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '8px', fontFamily: 'Montserrat, sans-serif' }}>Core Values</strong>
                  <h3 style={{ fontSize: '22px', fontWeight: '600', color: '#003c82', margin: '0 0 20px', fontFamily: 'Montserrat, sans-serif' }}>Guiding us through all that we do</h3>
                </div>
                <button
                  onClick={() => setActivePopup('values')}
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                    backgroundColor: '#003c82', color: '#ffffff',
                    padding: '10px 20px', fontSize: '13px', fontWeight: '600',
                    border: 'none', cursor: 'pointer',
                    fontFamily: 'Montserrat, sans-serif', alignSelf: 'flex-start'
                  }}>
                  View More
                </button>
              </div>
            </div>

            {/* Total Rewards Card */}
            <div style={{ backgroundColor: '#ffffff', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
              <div style={{ height: '240px', overflow: 'hidden' }}>
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_11539644e-1777272191654.png"
                  alt="Employee benefits and total rewards package at Brickwell Housing"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
              </div>
              <div style={{ padding: '28px 24px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  <strong style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#00b195', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '8px', fontFamily: 'Montserrat, sans-serif' }}>Total Rewards</strong>
                  <h3 style={{ fontSize: '22px', fontWeight: '600', color: '#003c82', margin: '0 0 20px', fontFamily: 'Montserrat, sans-serif' }}>So much more than a paycheck</h3>
                </div>
                <button
                  onClick={() => setActivePopup('rewards')}
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                    backgroundColor: '#003c82', color: '#ffffff',
                    padding: '10px 20px', fontSize: '13px', fontWeight: '600',
                    border: 'none', cursor: 'pointer',
                    fontFamily: 'Montserrat, sans-serif', alignSelf: 'flex-start'
                  }}>
                  View More
                </button>
              </div>
            </div>

            {/* Inclusion Card */}
            <div style={{ backgroundColor: '#ffffff', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
              <div style={{ height: '240px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa' }}>
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_145a6417e-1777272191586.png"
                  alt="Diverse hands raised together representing inclusion and belonging at Brickwell Housing"
                  style={{ maxWidth: '80%', maxHeight: '200px', objectFit: 'contain', display: 'block' }} />
              </div>
              <div style={{ padding: '28px 24px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div>
                  <strong style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#00b195', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '8px', fontFamily: 'Montserrat, sans-serif' }}>Inclusion and Belonging</strong>
                  <h3 style={{ fontSize: '22px', fontWeight: '600', color: '#003c82', margin: '0 0 20px', fontFamily: 'Montserrat, sans-serif' }}>You can feel at home here</h3>
                </div>
                <button
                  onClick={() => setActivePopup('inclusion')}
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                    backgroundColor: '#003c82', color: '#ffffff',
                    padding: '10px 20px', fontSize: '13px', fontWeight: '600',
                    border: 'none', cursor: 'pointer',
                    fontFamily: 'Montserrat, sans-serif', alignSelf: 'flex-start'
                  }}>
                  View More
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── GROWING BEYOND THE JOB ── */}
      <section
        id="beyond-the-job"
        style={{ padding: '80px 0', backgroundColor: '#ffffff' }}>

        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <h2
            style={{
              fontSize: 'clamp(28px, 3vw, 40px)',
              fontWeight: 400,
              color: '#003c82',
              textAlign: 'center',
              marginBottom: '48px',
              fontFamily: 'Montserrat, sans-serif'
            }}>
            Growing Beyond The Job
          </h2>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '0'
            }}
            className="teaser-grid">

            {teaserCards.map((card) =>
            <div key={card.title} style={{ overflow: 'hidden' }}>
                <div style={{ height: '240px', overflow: 'hidden' }}>
                  <img
                  src={card.image}
                  alt={card.alt}
                  style={{
                    width: '100%', height: '100%',
                    objectFit: 'cover', display: 'block',
                    transition: 'transform 0.4s ease'
                  }}
                  onMouseEnter={(e) => {(e.currentTarget as HTMLImageElement).style.transform = 'scale(1.05)';}}
                  onMouseLeave={(e) => {(e.currentTarget as HTMLImageElement).style.transform = 'scale(1)';}} />
                </div>
                <div
                style={{
                  backgroundColor: '#003c82',
                  padding: '32px 28px',
                  color: '#ffffff'
                }}>
                  <h3
                  style={{
                    fontSize: '20px', fontWeight: '600',
                    color: '#ffffff', marginBottom: '12px',
                    fontFamily: 'Montserrat, sans-serif'
                  }}
                  dangerouslySetInnerHTML={{ __html: card.title }} />
                  <p style={{ fontSize: '14px', lineHeight: '1.6', color: 'rgba(255,255,255,0.85)', margin: 0, fontFamily: 'Montserrat, sans-serif' }}>
                    {card.description}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ── FIND YOUR WORK HOME ── */}
      <section
        id="our-teams"
        style={{
          padding: '80px 0',
          backgroundColor: '#f8f9fa',
          position: 'relative'
        }}>

        {/* Background pattern */}
        <div
          style={{
            position: 'absolute', inset: 0,
            backgroundImage: 'url(https://tmo.com/wp-content/uploads/2024/07/pattern-bg-01.png)',
            backgroundRepeat: 'repeat',
            opacity: 0.15,
            pointerEvents: 'none'
          }} />

        <div style={{ position: 'relative', zIndex: 1, maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <h2
            style={{
              fontSize: 'clamp(28px, 3vw, 40px)',
              fontWeight: 400,
              color: '#003c82',
              textAlign: 'center',
              marginBottom: '48px',
              fontFamily: 'Montserrat, sans-serif'
            }}>
            Find Your Work Home
          </h2>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '0'
            }}
            className="team-grid">

            {teamCards.map((card) =>
            <div
              key={card.title}
              onClick={() => openTeamPopup(card)}
              style={{
                position: 'relative', overflow: 'hidden',
                cursor: 'pointer', height: '320px'
              }}
              className="team-card">

                <img
                src={card.image}
                alt={card.alt}
                style={{
                  width: '100%', height: '100%',
                  objectFit: 'cover', display: 'block',
                  transition: 'transform 0.4s ease'
                }} />

                {/* Overlay */}
                <div
                style={{
                  position: 'absolute', inset: 0,
                  background: 'linear-gradient(to top, rgba(0,60,130,0.85) 0%, rgba(0,60,130,0.2) 60%, transparent 100%)',
                  transition: 'opacity 0.3s ease'
                }} />

                {/* Title */}
                <div
                style={{
                  position: 'absolute', bottom: 0, left: 0, right: 0,
                  padding: '24px 20px',
                  display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between'
                }}>
                  <h3
                  style={{
                    fontSize: '18px', fontWeight: '600',
                    color: '#ffffff', margin: 0,
                    fontFamily: 'Montserrat, sans-serif',
                    lineHeight: 1.3
                  }}>
                    {card.title}
                  </h3>
                  <svg width="24" height="24" viewBox="0 0 39 32" fill="none" stroke="white" strokeWidth="1.5">
                    <path d="M22.721 1.228l15.015 15.015-15.015 15.015" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M37.791 16.242h-37.606" strokeLinecap="round" />
                  </svg>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section
        id="cta-careers"
        style={{
          padding: '80px 0',
          backgroundColor: '#ffffff'
        }}>

        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              overflow: 'hidden',
              minHeight: '300px'
            }}
            className="cta-grid">

            {/* Image */}
            <div className="cta-image" style={{ overflow: 'hidden', position: 'relative' }}>
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_196e0d854-1777272201165.png"
                alt="Brickwell Housing team member working in a community garden"
                style={{
                  width: '100%', height: '100%',
                  objectFit: 'cover', display: 'block'
                }} />
              {/* Diagonal cut */}
              <div
                style={{
                  position: 'absolute', top: 0, right: -1, bottom: 0,
                  width: '80px',
                  background: '#6dcff6',
                  clipPath: 'polygon(100% 0, 100% 100%, 0 100%)'
                }} />
            </div>
            {/* Content */}
            <div
              style={{
                backgroundColor: '#6dcff6',
                padding: '60px 48px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}>
              <h2
                style={{
                  fontSize: 'clamp(28px, 3vw, 44px)',
                  fontWeight: 400,
                  color: '#003c82',
                  marginBottom: '32px',
                  fontFamily: 'Montserrat, sans-serif',
                  lineHeight: 1.2
                }}>
                Come <em style={{ fontStyle: 'italic' }}>lift</em> lives with us
              </h2>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* ── POPUPS ── */}
      <Popup
        isOpen={activePopup === 'values'}
        onClose={() => setActivePopup(null)}
        title="Core Values"
        items={coreValues} />

      <Popup
        isOpen={activePopup === 'rewards'}
        onClose={() => setActivePopup(null)}
        title="Total Rewards"
        items={totalRewards} />

      <Popup
        isOpen={activePopup === 'inclusion'}
        onClose={() => setActivePopup(null)}
        title="Inclusion and Belonging"
        items={inclusionItems} />

      <TeamPopup
        isOpen={teamPopupOpen}
        onClose={() => setTeamPopupOpen(false)}
        card={activeTeamCard} />


      {/* ── STYLES ── */}
      <style>{`
        /* Hero responsive */
        @media (max-width: 768px) {
          .careers-hero {
            min-height: 60vh !important;
          }
          .hero-content {
            padding: 0 16px !important;
          }
          .hero-content > div {
            padding-top: 100px !important;
            max-width: 100% !important;
          }
          .hero-triangle {
            height: 60px !important;
            width: 60% !important;
          }
        }
        @media (max-width: 480px) {
          .careers-hero {
            min-height: 50vh !important;
          }
          .hero-triangle {
            display: none !important;
          }
        }

        /* Testimonials */
        @media (max-width: 1024px) {
          .testimonials-grid {
            grid-template-columns: 1fr 1fr !important;
          }
          .testimonials-grid > div:last-child {
            display: none;
          }
        }
        @media (max-width: 768px) {
          .testimonials-grid {
            grid-template-columns: 1fr !important;
          }
          .testimonials-grid > div:nth-child(2),
          .testimonials-grid > div:last-child {
            display: none;
          }
        }

        /* Why Brickwell */
        @media (max-width: 1024px) {
          .why-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
        }

        /* Benefits */
        @media (max-width: 1024px) {
          .benefits-grid {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width: 768px) {
          .benefits-grid {
            grid-template-columns: 1fr !important;
          }
        }

        /* Teaser / Growing Beyond */
        @media (max-width: 1024px) {
          .teaser-grid {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width: 640px) {
          .teaser-grid {
            grid-template-columns: 1fr !important;
          }
        }

        /* Team grid */
        @media (max-width: 1024px) {
          .team-grid {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width: 480px) {
          .team-grid {
            grid-template-columns: 1fr !important;
          }
        }

        /* CTA grid */
        @media (max-width: 768px) {
          .cta-grid {
            grid-template-columns: 1fr !important;
          }
          .cta-image {
            height: 240px !important;
          }
          .cta-grid > div:last-child {
            padding: 40px 24px !important;
          }
        }

        /* Popup responsive */
        @media (max-width: 640px) {
          .popup-inner {
            width: 95% !important;
            max-height: 95vh !important;
          }
          .popup-content {
            flex-direction: column !important;
          }
          .popup-image {
            width: 100% !important;
            height: 200px !important;
            flex-shrink: 0 !important;
          }
          .popup-content > div:last-child {
            padding: 24px 20px !important;
          }
        }

        /* Section padding on mobile */
        @media (max-width: 640px) {
          #testimonials,
          #why-brickwell,
          #values-benefits-dei,
          #beyond-the-job,
          #our-teams,
          #cta-careers {
            padding: 48px 0 !important;
          }
        }

        .team-card:hover img {
          transform: scale(1.05);
        }
        .team-card:hover > div:nth-child(2) {
          opacity: 1;
        }
      `}</style>
    </>);
}